export type GraphNodeType =
  | "asset"
  | "fpso"
  | "equipment"
  | "contractor"
  | "system"
  | "document";

export interface GraphNode {
  id: string;
  type: GraphNodeType;
  label: string;
  // Position of the node's center, expressed as a percentage of the canvas.
  top: number;
  left: number;
  highlighted?: boolean;
}

export interface GraphEdge {
  fromId: string;
  toId: string;
  label: string;
}

export interface RelationshipEntry {
  name: string;
  target: string;
}

export interface KeyValueEntry {
  label: string;
  value: string;
}

export interface ApprovalStageBadge {
  label: string;
  tone: "amber" | "blue" | "green";
}

export interface SelectedConcept {
  name: string;
  statusLabel: string;
  definition: string;
  attributes: string[];
  relationships: RelationshipEntry[];
  source: string;
  reuseClassification: string;
  lineageProvenance: KeyValueEntry[];
  approvalStatusLifecycle: ApprovalStageBadge[];
}

// Dummy graph data matching Figma node 3589:85345 (Build Knowledge Graph workspace).
export const GRAPH_NODES: GraphNode[] = [
  { id: "asset", type: "asset", label: "Asset", top: 13, left: 9 },
  { id: "fpso", type: "fpso", label: "FPSO", top: 13, left: 50 },
  {
    id: "contractor",
    type: "contractor",
    label: "Contractor",
    top: 41,
    left: 50
  },
  {
    id: "equipment",
    type: "equipment",
    label: "Equipment",
    top: 48,
    left: 26,
    highlighted: true
  },
  { id: "system", type: "system", label: "System", top: 76, left: 9 },
  { id: "document", type: "document", label: "Document", top: 76, left: 50 }
];

export const GRAPH_EDGES: GraphEdge[] = [
  { fromId: "equipment", toId: "asset", label: "contains" },
  { fromId: "equipment", toId: "fpso", label: "belongs to" },
  { fromId: "equipment", toId: "contractor", label: "delivered by" },
  { fromId: "equipment", toId: "system", label: "maintained by" },
  { fromId: "equipment", toId: "document", label: "documented by" }
];

export const SELECTED_CONCEPT: SelectedConcept = {
  name: "Equipment",
  statusLabel: "Approved",
  definition:
    "A physical object or functional entity designed and manufactured to perform a specific engineering role within upstream assets and offshore pipeline assemblies.",
  attributes: ["equipmentUID", "manufacturer", "operatingTemp", "safetyClass"],
  relationships: [
    { name: "belongsTo", target: "FPSO" },
    { name: "maintainedBy", target: "Contractor" },
    { name: "deliveredBy", target: "Contractor" },
    { name: "linkedTo", target: "Document" }
  ],
  source: "ISO 14224 / API 610 Standards",
  reuseClassification: "Standard Enterprise Concept",
  lineageProvenance: [
    { label: "Reuse Origin", value: "Reused from O&G Starter Kit" },
    { label: "Source Ontology", value: "CFIHOS Standard" },
    { label: "Version", value: "Version 1.5" },
    { label: "Reuse Classification", value: "Direct Reuse" }
  ],
  approvalStatusLifecycle: [
    { label: "AI Proposed", tone: "amber" },
    { label: "SME Reviewed", tone: "blue" },
    { label: "Approved", tone: "green" }
  ]
};
